import { render, staticRenderFns } from "./DossierInProgressChart.vue?vue&type=template&id=9496d4d8&scoped=true&"
import script from "./DossierInProgressChart.vue?vue&type=script&lang=js&"
export * from "./DossierInProgressChart.vue?vue&type=script&lang=js&"
import style0 from "./DossierInProgressChart.vue?vue&type=style&index=0&id=9496d4d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9496d4d8",
  null
  
)

export default component.exports